<p-toast></p-toast>
<div class="card header-box" reflow="true">
    <div class="flex flex-wrap field">
        <div class="field">
            <label for="name" class="mr-6">{{'AADHAR_NUMBER' | translate}}:</label>
            <input type="text" [ngStyle]="{'color': 'balck', 'background-color': inputPhone ? 'rgb(213, 209, 209)' : 'white'}" pInputText id="name" [attr.disabled]="inputPhone ? true : null" [(ngModel)]="inputId"
                required autofocus />
        </div>
        <div class="field">
            <label for="phone" class="mr-6">{{'PHONE_NO' | translate}}:</label>
            <input type="text" [ngStyle]="{'color': 'balck', 'background-color': inputId ? 'rgb(213, 209, 209)' : 'white'}" pInputText id="phone" [attr.disabled]="inputId ? true : null" [(ngModel)]="inputPhone"
                required autofocus />
        </div>
    </div>
    <!-- <div class="flex flex-wrap align-items-center justify-content-center mt-5">
        <button pButton pRipple label="{{'GET_APPLICATION_STATUS' | translate}}" class="p-button-success"
            (click)="getApplicationStatus()"></button>
    </div> -->
    <div class="flex flex-wrap align-items-center justify-content-center mt-5">
        <div *ngIf="tableData.length == 0" class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button pButton pRipple label="{{'Get Beneficiary Details' | translate}}" class="p-button-success"
                (click)="getApplicationStatus()"></button>
        </div>

        <div *ngIf="tableData.length > 0" class="d-flex justify-content-center align-items-center vh-100 mt-2">
            <button (click)="clearData()" pButton pRipple label="{{ 'Clear Details' | translate }}"
                class="p-button-help"></button>
        </div>
    </div>
</div>

<p-table *ngIf="tableData.length > 0" [columns]="cols" [value]="tableData" [rows]="10" [paginator]="true"
    [globalFilterFields]="['Aadhar', 'Application_ID', 'Area', 'Category', 'Department', 'District', 'FarmerName', 'FatherName', 'JEVerificationAmount', 'LandDetails', 'Mobile', 'Registration_Date', 'TotalCostVerification', 'Vendor_Name', 'Village', 'Year', 'system']"
    responsiveLayout="scroll" [rowHover]="true" dataKey="Application_ID"
    currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
    [showCurrentPageReport]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}">

    <ng-template pTemplate="caption">
        <div class="grid d-flex align-items-center justify-content-end">
            <!-- Left side -->
            <div class="col-7">
                <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'rgb(153, 36, 30)'}">{{ tableHeaderName | translate}}</h5>
            </div>
            <div class="col-12 md:col-5 gap-3 d-flex align-items-center justify-content-end">
                <!-- <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                </span> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                <p-menu #menu [popup]="true" [model]="BenificiaryReport"></p-menu>
            </div>
        </div>
    </ng-template>

    <!-- <ng-template pTemplate="header">
        <tr>
            <th>{{ 'S_NO' | translate }}</th>
            <th>{{ 'AADHAR_NO' | translate }}</th>
            <th>{{ 'APPLICATION_ID' | translate }}</th>
            <th>{{ 'AREA' | translate }}</th>
            <th>{{ 'CATEGORY_NAME' | translate }}</th>
            <th>{{ 'DEPARTMENT' | translate }}</th>
            <th>{{ 'FARMER_NAME' | translate }}</th>
            <th>{{ 'FATHER_NAME' | translate }}</th>
            <th>{{ 'JE_Verification_Amount' | translate }}</th>
            <th>{{ 'LAND_DETAIL' | translate }}</th>
            <th>{{ 'MOBILE_NO' | translate }}</th>
            <th>{{ 'REGISTRATION_DATE' | translate }}</th>
            <th>{{ 'Total_Cost_Verification' | translate }}</th>
            <th>{{ 'VENDOR_NAME' | translate }}</th>
            <th>{{ 'VILLAGE' | translate }}</th>
            <th>{{ 'YEAR' | translate }}</th>
            <th>{{ 'SYSTEM' | translate }}</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
        <tr>
            <td>{{ ri + 1 }}</td>
            <td>{{ consolidateData?.Aadhar }}</td>
            <td>{{ consolidateData?.Application_ID }}</td>
            <td>{{ consolidateData?.Area }}</td>
            <td>{{ consolidateData?.Category }}</td>
            <td>{{ consolidateData?.Department }}</td>
            <td>{{ consolidateData?.FarmerName }}</td>
            <td>{{ consolidateData?.FatherName }}</td>
            <td>{{ consolidateData?.JEVerificationAmount }}</td>
            <td>{{ consolidateData?.LandDetails }}</td>
            <td>{{ consolidateData?.Mobile }}</td>
            <td>{{ consolidateData?.Registration_Date }}</td>
            <td>{{ consolidateData?.TotalCostVerification }}</td>
            <td>{{ consolidateData?.Vendor_Name }}</td>
            <td>{{ consolidateData?.Village }}</td>
            <td>{{ consolidateData?.Year }}</td>
            <td>{{ consolidateData?.system }}</td>
        </tr>
    </ng-template> -->

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">
                {{ col }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                {{ rowData[col] }}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7">No Data found.</td>
        </tr>
    </ng-template>

</p-table>

<router-outlet></router-outlet>
